// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseTable_container_2r7Rh","borderless":"BaseTable_borderless_20IT0"};